import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Outletouterpage from '../../../components/dashboard/outletouterpage/outletouterpage';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import EnablingFeature from '../../../components/EnablingFeature';
import { CustomerWalletBalances } from '../../../components/CustomerWalletBalances';
import { ChevronLeftIcon } from '../../../components/icons';

const PaymentsOverview = () => {
    const state = useSelector((state: RootState) => ({
        user: state.user.user
    }));

    const { user } = state;

    const location = useLocation();
    const navigate = useNavigate();

    return (
        <EnablingFeature flag='Payments'>
            <div className='relative w-full max-w-[100vw] overflow-hidden'>
                <Outletouterpage>
                    <div className='hidden lg:flex justify-between  mb-4'>
                        <h1 className='text-[20px] font-medium text-gray200'>
                            Payment
                        </h1>
                    </div>
                    <div className='w-full pt-6'>
                        {location.pathname.split('/')[2] === 'make-payment' ? (
                            <button
                                className='lg:hidden flex gap-[12px] items-center px-4 mb-4 font-medium text-lg text-ebony'
                                onClick={() =>
                                    navigate('/payments/transactions')
                                }
                            >
                                <ChevronLeftIcon /> Make payment
                            </button>
                        ) : (
                            <h1 className='lg:hidden  mb-4 text-xl text-black  px-4 lg:px-0'>
                                Transactions
                            </h1>
                        )}

                        <div className='lg:pl-0 px-4 lg:px-0'>
                            <CustomerWalletBalances />
                        </div>

                        <div className='mt-[40px] lg:mt-12 view-add-transactions'>
                            <Outlet />
                        </div>
                    </div>
                </Outletouterpage>
            </div>
        </EnablingFeature>
    );
};

export default PaymentsOverview;
